// extracted by mini-css-extract-plugin
export default {"customers":"SM","wrapper":"TM","carousel":"UM","carousel_inner_wrapper":"VM","top_quote":"WM","bottom_quote":"XM","carousel_wrapper":"YM","feedbacks_wrapper":"ZM","arrows":"aN","prev":"bN","img":"cN","review_btn":"eN"};
    if(module.hot) {
      // 1714422956778
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  